import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export let Item = ({label, children, tabletFullWidth, mobileFullWidth, fullWidth}) => (
    <div key={label}
         className={classNames([
             'gx-summary-list__item',
             fullWidth && 'gx-summary-list__item--fullWidth',
             mobileFullWidth && 'gx-summary-list__item--fullWidthMobile',
             tabletFullWidth && 'gx-summary-list__item--fullWidthTablet'
         ])}>
        <div className='gx-summary-list__label'>{label}</div>
        <div className='gx-summary-list__value'>{children}</div>
    </div>
);

Item.propTypes = {
    label: PropTypes.string,
    fullWidth: PropTypes.bool,
    tabletFullWidth: PropTypes.bool,
    mobileFullWidth: PropTypes.bool,
};
